import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-curtain-angular',
  templateUrl: './curtain-angular.component.html',
  styleUrls: ['./curtain-angular.component.scss']
})
export class CurtainAngularComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
